import { Field, Input, Label } from "@fluentui/react-components";
import { StackItemShim, StackShim } from "@fluentui/react-migration-v8-v9";
import i18n from "i18next";
import { helperMethods } from "../../helpers/helperMethods";
import { useEffect, useState } from "react";
import { MmInch } from "../../helpers/mminch";

export interface IMeasurements {
  inch: number | string;
  inchDez: number | string;
  mm: number | string;
}

interface IMeasurementInputsProps {
  onFocus?: () => void;
  title: string;
  readonly?: boolean;
  tabIndex: number;
  currentMeasurements: IMeasurements;
  appearance?:
    | "outline"
    | "underline"
    | "filled-darker"
    | "filled-lighter"
    | "filled-darker-shadow"
    | "filled-lighter-shadow"
    | undefined;
  onChangeMeasurements: (measurements: IMeasurements) => void;
}

const MeasurementInputs = (props: IMeasurementInputsProps) => {
  const [newMeasurements, setNewMeasurements] = useState<IMeasurements>();
  useEffect(() => {
    setNewMeasurements(props.currentMeasurements);
  }, [props.currentMeasurements]);
  const checkInput = (inputValue: string): boolean => {
    if (
      !Number.isNaN(Number(inputValue)) ||
      inputValue.includes("/") ||
      inputValue.includes(",") ||
      inputValue.includes(" ") ||
      inputValue == ""
    ) {
      return true;
    } else return false;
  };
  const getValFromArray = (array: any, field: string) => {
    let test = undefined;
    for (var i = 0, iLen = Object.entries(array).length; i < iLen; i++) {
      // do stuff with node.childNodes[i];
      if (Object.entries(array)[i][0] == field) {
        test = Object.entries(array)[i][1];
      }
    }
    return test;
  };
  const mmConverter = () => {
    const mmValue = newMeasurements?.mm;
    const mm = helperMethods.convertToNumber(mmValue as string);
    props.onChangeMeasurements({
      mm: mm.toLocaleString(i18n.language, {
        maximumFractionDigits: 3,
      }),
      inchDez: (mm / 25.4).toLocaleString(i18n.language, {
        maximumFractionDigits: 3,
      }),
      inch: mm ? MmInch.toInch(mm) : "",
    });
  };
  const inchConverter = () => {
    const inchDezValue = newMeasurements?.inchDez;
    const asNumber = helperMethods.convertToNumber(inchDezValue);
    const mm = helperMethods.convertToNumber(MmInch.toMM(asNumber));
    props.onChangeMeasurements({
      mm: mm.toLocaleString(i18n.language, {
        maximumFractionDigits: 3,
      }),
      inchDez: asNumber.toLocaleString(i18n.language, {
        maximumFractionDigits: 3,
      }),
      inch: asNumber == 0 ? "" : MmInch.toInch(mm),
    });
  };
  const fractionalConverter = () => {
    const inchValue = newMeasurements?.inch;
    var fixedFraction = (inchValue as string)
      .replace(",", "")
      .replace(/\s*\/\s*/g, "/");

    const mm = helperMethods.convertToNumber(MmInch.toMM(fixedFraction));
    props.onChangeMeasurements({
      mm: mm.toLocaleString(i18n.language, {
        maximumFractionDigits: 3,
      }),
      inchDez: (mm / 25.4).toLocaleString(i18n.language, {
        maximumFractionDigits: 3,
      }),
      inch: fixedFraction,
    });
  };

  return (
    <>
      <Label style={{ marginTop: "10px" }}>{i18n.t<string>(props.title)}</Label>
      {newMeasurements != undefined && (
        <StackShim horizontal tokens={{ childrenGap: 5 }} wrap={true}>
          <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
            <Field>
              <Input
                onFocus={(event) => {
                  event.target.select();
                  if (props.onFocus) {
                    props.onFocus();
                  }
                }}
                appearance={props.appearance}
                readOnly={props.readonly ?? false}
                autoComplete="off"
                contentBefore={"mm"}
                tabIndex={props.tabIndex}
                onBlur={() => {
                  props.onChangeMeasurements({
                    mm: newMeasurements.mm,
                    inchDez: newMeasurements.inchDez,
                    inch: newMeasurements.inch,
                  });
                  mmConverter();
                }}
                value={newMeasurements.mm.toLocaleString(undefined, {
                  maximumFractionDigits: 3,
                })}
                onKeyDown={(e: any) => {
                  if (e.key == "Enter") {
                    props.onChangeMeasurements({
                      mm: newMeasurements.mm,
                      inchDez: newMeasurements.inchDez,
                      inch: newMeasurements.inch,
                    });
                    mmConverter();
                  }
                }}
                onChange={(ev, data) => {
                  if (checkInput(data.value)) {
                    var tempMeasure = { ...newMeasurements };
                    tempMeasure.mm = data.value;
                    setNewMeasurements(tempMeasure);
                  }
                }}
              />
            </Field>
          </StackItemShim>
          <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
            <Field>
              <Input
                appearance={props.appearance}
                readOnly={props.readonly ?? false}
                onFocus={(event) => {
                  event.target.select();
                  if (props.onFocus) {
                    props.onFocus();
                  }
                }}
                autoComplete="off"
                contentBefore={"inch/dez"}
                onBlur={() => {
                  props.onChangeMeasurements({
                    mm: newMeasurements.mm,
                    inchDez: newMeasurements.inchDez,
                    inch: newMeasurements.inch,
                  });
                  inchConverter();
                }}
                value={newMeasurements.inchDez.toLocaleString(undefined, {
                  maximumFractionDigits: 3,
                })}
                onKeyDown={(e: any) => {
                  if (e.key == "Enter") {
                    props.onChangeMeasurements({
                      mm: newMeasurements.mm,
                      inchDez: newMeasurements.inchDez,
                      inch: newMeasurements.inch,
                    });
                    inchConverter();
                  }
                }}
                onChange={(ev, data) => {
                  if (checkInput(data.value)) {
                    var tempMeasure = { ...newMeasurements };
                    tempMeasure.inchDez = data.value;
                    setNewMeasurements(tempMeasure);
                  }
                }}
              />
            </Field>
          </StackItemShim>
          <StackItemShim grow={1} style={{ paddingLeft: 5, paddingRight: 5 }}>
            <Field>
              <Input
                appearance={props.appearance}
                readOnly={props.readonly ?? false}
                onFocus={(event) => {
                  event.target.select();
                  if (props.onFocus) {
                    props.onFocus();
                  }
                }}
                contentBefore={"inch"}
                autoComplete="off"
                inputMode="text"
                onBlur={() => {
                  props.onChangeMeasurements({
                    mm: newMeasurements.mm,
                    inchDez: newMeasurements.inchDez,
                    inch: newMeasurements.inch,
                  });
                  fractionalConverter();
                }}
                value={
                  newMeasurements.inch == ""
                    ? "0"
                    : newMeasurements.inch.toString()
                }
                onKeyDown={(e: any) => {
                  if (e.key == "Enter") {
                    props.onChangeMeasurements({
                      mm: newMeasurements.mm,
                      inchDez: newMeasurements.inchDez,
                      inch: newMeasurements.inch,
                    });
                    fractionalConverter();
                  }
                }}
                onChange={(ev, data) => {
                  if (checkInput(data.value)) {
                    var tempMeasure = { ...newMeasurements };
                    tempMeasure.inch = data.value;
                    setNewMeasurements(tempMeasure);
                  }
                }}
              />
            </Field>
          </StackItemShim>
        </StackShim>
      )}
    </>
  );
};
export default MeasurementInputs;
